import React, { useEffect, useState, useCallback } from 'react';
import { injectIntl } from "react-intl";
import { userAvatar } from '../../utils/images';
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import { useHistory } from 'react-router-dom';
import './style.scss';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../store/users/actions';
import PhoneInputComponent from '../Controls/PhoneInput/PhoneInput';
import moment from 'moment';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { arabicConvertor } from '../../utils/Shared';

function UserForm({ intl: { messages }, user }) {
    const history = useHistory();
    const dispatch = useDispatch();
    const [isMultiSteps, setIsMultiSteps] = useState(false);
    const [cancelConfirmation, setCancelConfirmation] = useState(false);
    const { valideEmail, emailError, valideMobile, mobileError } = useSelector(state => state?.users);
    const [step, setStep] = useState(1);
    const [feedback, setFeedback] = useState('');
    const lang = localStorage.getItem('lang');

    const usersList = [
        {id: 1, name: messages.users.admin},
        {id: 2, name: messages.users.receptionist},
        {id: 3, name: messages.users.coordinator},
        {id: 4, name: messages.users.specialist},
        {id: 6, name: messages.users.consultant},
        {id: 5, name: messages.users.accountant},
    ];

    const daysList = [
        messages.users.form.sunday,
        messages.users.form.monday,
        messages.users.form.tuesday,
        messages.users.form.wednesday,
        messages.users.form.thursday,
        messages.users.form.friday,
        messages.users.form.saturday,
    ];

    const [formData, setFormData] = useState({
        user_code: '',
        name: {
            en: '',
            ar: ''
        },
        role_id: 0,
        email: '',
        phone_number: '',
        profile_image: null,
        schedules: [],
    });

    const clear = () => {
        setFormData({
            user_code: '',
            name: {
                en: '',
                ar: ''
            },
            role_id: 0,
            email: '',
            phone_number: '',
            profile_image: null,
            schedules: [],
        });
        setStep(1);
        document.getElementById('code').style.borderColor = '#eee';
        document.getElementById('enname').style.borderColor = '#eee';
        document.getElementById('arname').style.borderColor = '#eee';
        document.getElementById('position').style.borderColor = '#eee';
        document.getElementById('email').style.borderColor = '#eee';
        document.getElementById('phone').style.borderColor = '#eee';
        setFeedback('');
        dispatch(actions.cleanErrors());
        document.getElementById('code').focus();
    }

    const rebuildSchedule = (schedule) => {
        let newSchedule = [];
        if (schedule) {
            daysList.forEach((day, index) => {
                let newItem = {
                    day: index + 1,
                    from_hour: schedule[index] ? schedule[index].from_hour : '',
                    to_hour: schedule[index] ? schedule[index].to_hour : '',
                    is_working_day: schedule[index] ? schedule[index].is_working_day : false,
                    has_sections: schedule[index] ? schedule[index].has_sections : false,
                    schedule_sections: schedule[index] ? schedule[index].has_sections === true ? schedule[index].schedule_sections : [
                        {
                            from_hour: '',
                            to_hour: '',
                        },
                    ] : []
                };
                newSchedule.push(newItem);
            });
        }
        return newSchedule;
    }

    useEffect(() => {
        if (user) {
            setFormData({
                id: user.id,
                user_code: user.username,
                name: {
                    en: user?.name?.en,
                    ar: user?.name?.ar
                },
                role_id: user.role_id,
                email: user.email,
                phone_number: user.phone_number?.replace(/\+/g, ""),
                profile_image: user.profile_image,
                schedules: rebuildSchedule(user.schedules),
            });
            if (user.role_id === 4 || user.role_id === 6) {
                setIsMultiSteps(true);
                setStep(1);
            } else {
                setIsMultiSteps(false);
                setStep(1);
            }
        } else {
            clear();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    // Check if is multi steps - on changing user role select
    useEffect(() => {
        if (parseInt(formData.role_id) === 4 || parseInt(formData.role_id) === 6) {
            setIsMultiSteps(true);

        } else {
            setIsMultiSteps(false);
        }
    }, [formData]);

    // Blur Event Callback - Email Input
    const blurEmail = useCallback((e) => {
        if (e.target.value !== '') {
            if (!user) {
                dispatch(actions.validateEmailRequest(e.target.value));
            } else {
                if (user.email !== e.target.value) {
                    dispatch(actions.validateEmailRequest(e.target.value));
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    // Handle Blur Event - Email input
    useEffect(() => {
        document.getElementById('email').addEventListener('blur', blurEmail);
        return () => {
            document.getElementById('email').removeEventListener('blur', blurEmail);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Validate Email input
    useEffect(() => {
        if (valideEmail || document.getElementById('email').value === '') {
            document.getElementById('email').style.borderColor = '#eee';
            setFeedback('');
        } else {
            document.getElementById('email').style.borderColor = '#d58c8c';
            setFeedback(emailError);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [valideEmail, emailError]);

     // Blur Event Callback - Phone Input
    const blurPhone = useCallback((e) => {
        if (e.target.value !== '') {
            if (!user) {
                dispatch(actions.validateMobileRequest(e.target.value));
            } else {
                if (user.phone_number !== `+${e.target.value}`) {
                    dispatch(actions.validateMobileRequest(e.target.value));
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    // Handle Blur Event - Phone input
    useEffect(() => {
        document.getElementById('phone').addEventListener('blur', blurPhone);
        return () => {
            document.getElementById('phone').removeEventListener('blur', blurPhone);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //Validate Mobile input
    useEffect(() => {
        if (valideMobile || document.getElementById('phone').value === '') {
            document.getElementById('phone').style.borderColor = '#eee';
            setFeedback('');
        } else {
            document.getElementById('phone').style.borderColor = '#d58c8c';
            setFeedback(messages.users.form.phone_invalid);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [valideMobile]);

    useEffect(() => {
        if (mobileError && mobileError.length > 0) {
            document.getElementById('phone').style.borderColor = '#d58c8c';
            setFeedback(mobileError);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mobileError]);
    
    // Validation
    const firstStepValidation = () => {
        let isValid = true;
        if (formData.role_id === 0) {
            document.getElementById('position').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.users.form.position_invalid);
        }
        if (formData.email === '' || !valideEmail) {
            document.getElementById('email').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.users.form.email_invalid);
        }
        if (formData.phone_number === '' || !valideMobile) {
            document.getElementById('phone').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.users.form.phone_invalid);
        }
        if (formData.name.ar === '') {
            document.getElementById('arname').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.users.form.ar_name_invalid);
        }
        if (formData.name.en === '') {
            document.getElementById('enname').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.users.form.en_name_invalid);
        }
        if (!user && (formData.user_code?.length < 2 || formData.user_code?.length > 3)) {
            document.getElementById('code').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.users.form.code_invalid);
        }
        if ((formData.user_code?.length < 2 || formData.user_code?.length > 3) && formData.name?.en === '' && formData.name?.ar === '' && formData.role_id === 0 ) {
            setFeedback(messages.users.form.all_fields_required);
        }
        return isValid;
    }

    const secondStepValidation = () => {
        let validScedules = true;
        formData.schedules?.map((item) => {
            if (item.is_working_day) {
                if (moment(item.to_hour, 'HH:mm').diff(moment(item.from_hour, 'HH:mm'), 'minutes') < 120) {
                    setFeedback(messages.users.form.schedule_invalid_2h);
                    validScedules = false;
                }
                /* if (!moment(item.to_hour, 'HH:mm').isValid() || !moment(item.from_hour, 'HH:mm').isValid()) {
                    setFeedback(messages.users.form.time_invalid);
                    validScedules = false;
                } */
                if (item.to_hour === '' || item.from_hour === '') {
                    setFeedback(messages.users.form.working_hours_invalid);
                    validScedules = false;
                }

                item.schedule_sections?.forEach((section) => {
                    if (item.has_sections) {
                        if (moment(section.to_hour, 'HH:mm').diff(moment(item.to_hour, 'HH:mm'), 'minutes') > 0) {
                            setFeedback(messages.users.form.schedule_invalid_section);
                            validScedules = false;
                        }
                        if (moment(section.from_hour, 'HH:mm').diff(moment(item.from_hour, 'HH:mm'), 'minutes') < 0 || moment(section.from_hour, 'HH:mm').diff(moment(item.to_hour, 'HH:mm'), 'minutes') > 0) {
                            setFeedback(messages.users.form.schedule_invalid_section);
                            validScedules = false;
                        }
                        if (moment(section.to_hour, 'HH:mm').diff(moment(section.from_hour, 'HH:mm'), 'minutes') < 30) {
                            setFeedback(messages.users.form.schedule_invalid_30m);
                            validScedules = false;
                        }
                        /* if (moment(section.to_hour, 'HH:mm').isValid() && moment(section.from_hour, 'HH:mm').isValid()) {
                            setFeedback(messages.users.form.time_invalid);
                            validScedules = false;
                        } */
                        if (section.to_hour === '' || section.from_hour === '') {
                            setFeedback(messages.users.form.time_apps_required);
                            validScedules = false;
                        }
                    }
                })
            }
            return item
        })
        return validScedules;
    }

    // Next Function
    const handleNext = (e) => {
        e.preventDefault();       
        if (firstStepValidation()) {
            if (formData.schedules?.length === 0) {
                setFormData({
                    ...formData,
                    schedules: [
                        {
                            day: 1,
                            from_hour: '08:00',
                            to_hour: '16:00',
                            is_working_day: true,
                            has_sections: true,
                            schedule_sections: [
                                {
                                    from_hour: '',
                                    to_hour: '',
                                }
                            ]
                        },
                        {
                            day: 2,
                            from_hour: '08:00',
                            to_hour: '16:00',
                            is_working_day: true,
                            has_sections: true,
                            schedule_sections: [
                                {
                                    from_hour: '',
                                    to_hour: '',
                                },
                            ]
                        },
                        {
                            day: 3,
                            from_hour: '08:00',
                            to_hour: '16:00',
                            is_working_day: true,
                            has_sections: true,
                            schedule_sections: [
                                {
                                    from_hour: '',
                                    to_hour: '',
                                },
                            ]
                        },
                        {
                            day: 4,
                            from_hour: '08:00',
                            to_hour: '16:00',
                            is_working_day: true,
                            has_sections: true,
                            schedule_sections: [
                                {
                                    from_hour: '',
                                    to_hour: '',
                                },
                            ]
                        },
                        {
                            day: 5,
                            from_hour: '08:00',
                            to_hour: '16:00',
                            is_working_day: true,
                            has_sections: true,
                            schedule_sections: [
                                {
                                    from_hour: '',
                                    to_hour: '',
                                },
                            ]
                        },
                        {
                            day: 6,
                            from_hour: '08:00',
                            to_hour: '16:00',
                            is_working_day: false,
                            has_sections: false,
                            schedule_sections: null,
                        },
                        {
                            day: 7,
                            from_hour: '08:00',
                            to_hour: '16:00',
                            is_working_day: false,
                            has_sections: false,
                            schedule_sections: null,
                        },
                    ],
                });
            }
            setStep(2);
        }
    }

    // Back Function
    const handleBack = (e) => {
        e.preventDefault();
        if (user) {
            if (formData.user_code === user.user_code && formData.name.en === user.name.en && formData.name.ar === user.name.ar && formData.role_id === user.role_id && formData.email === user.email && formData.phone === `+${user.phone}`  && formData.schedules === user.schedules) {
                history.push('/users/internal');
            } else {
                setCancelConfirmation(true);
            }
        } else {
            if (step === 1) {
                if (formData.user_code === '' && formData.name.en === '' && formData.name.ar === '' && formData.role_id === 0 && formData.email === '' && formData.phone_number === '') {
                    clear();
                    history.push('/users/internal');
                } else {
                    setCancelConfirmation(true);
                }
            } else if (step === 2) {
                setStep(1);
            } 
        }
    }

    // Save Function
    const handleSave = (e) => {
        e.preventDefault()
        if (user) {
            if (firstStepValidation() && secondStepValidation()) {
                setFeedback('');
                let schedules = [];
                formData.schedules?.forEach((item) => {
                    if (item.is_working_day) {
                        schedules.push({
                            day: item.day,
                            from_hour: item.from_hour,
                            to_hour: item.to_hour,
                            schedule_sections: item.has_sections ? item.schedule_sections : [],
                        })
                    }
                })
                dispatch(actions.editUserRequest({
                    ...formData, 
                    schedules: user.role_id === 4 || user.role_id === 6 ? schedules : [], 
                    phone_number: `+${formData.phone_number}`
                }, history));
            }
        } else {
            if (step === 1) {
                if (firstStepValidation()) {
                    dispatch(actions.addUserRequest({...formData, phone_number: `+${formData.phone_number}`}, history));
                }
            } else {
                if (secondStepValidation()){
                    let schedules = [];
                    formData.schedules?.forEach((item) => {
                        if (item.is_working_day) {
                            schedules.push({
                                day: item.day,
                                from_hour: item.from_hour,
                                to_hour: item.to_hour,
                                schedule_sections: item.has_sections ? item.schedule_sections : [],
                            })
                        }
                    })
                    dispatch(actions.addUserRequest({...formData, schedules: schedules, phone_number: `+${formData.phone_number}`}, history));
                }
            }
        }
    }


    return (
        <div className='userform_container myform'>
            <form>
                <div className={`step ${step === 1 && 'show'}`}>
                    <h3>{messages.users.form.title}</h3>
                    <div className='avatar_input'>
                        <img src={formData.profile_image ? `${process.env.REACT_APP_BASE_URL}${formData.profile_image}` : userAvatar} alt="Avatar" />
                        <div id="avatarContainer"><input type="file" name="avatar" id="avatar" /></div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label htmlFor="code" className='required'>{messages.users.form.code}</label>
                            <input type="text" name="code" id="code" autoFocus={true}
                                    placeholder={messages.users.form.code_placeholder}
                                    maxLength={!user && 3}
                                    disabled={user && true}
                                    value={formData.user_code}
                                    onChange={e => {
                                        const re = /^[A-Za-z]+$/;
                                        if (e.target.value === "" || re.test(e.target.value)) {
                                            document.getElementById('code').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData({ ...formData, user_code: e.target.value })
                                        }
                                        }} />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="enname" className='required'>{messages.users.form.en_name}</label>
                            <input type="text" name="enname" id="enname"
                                    placeholder={messages.users.form.en_name_placeholder}
                                    value={formData.name.en} 
                                    onChange={e => {
                                        document.getElementById('enname').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ ...formData, name: { ...formData.name, en: e.target.value } })
                                        }} />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="arname" className='required'>{messages.users.form.ar_name}</label>
                            <input type="text" name="arname" id="arname"
                                    placeholder={messages.users.form.ar_name_placeholder}
                                    value={formData.name.ar}
                                    onChange={e => {
                                        document.getElementById('arname').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ ...formData, name: { ...formData.name, ar: arabicConvertor(e.target.value) } })
                                        }} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label htmlFor="phone" className='required'>{messages.users.form.mobile}</label>
                            
                                    <PhoneInputComponent name="phone" id="phone" lang={lang}
                                        myplaceholder={messages.users.form.mobile_placeholder}
                                        myvalue={formData.phone_number}
                                        onValueChange={(val) => {
                                            document.getElementById('phone').style.borderColor = '#eee';
                                            setFeedback('');
                                            setFormData({ ...formData, phone_number: val })
                                            }}
                                        />
                                
                            
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="email" className='required'>{messages.users.form.email}</label>
                            <input type="email" name="email" id="email"
                                placeholder={messages.users.form.email_placeholder}
                                value={formData.email}
                                onChange={e => {
                                    document.getElementById('email').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, email: e.target.value })
                                    }} />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="position" className='required'>{messages.users.form.position}</label>
                            <select name="position" id="position"
                                    value={formData.role_id}
                                    onChange={e => {
                                        document.getElementById('position').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ ...formData, role_id: e.target.value })
                                        }}
                                    disabled={user ? true : false}>
                                <option value={0}>{messages.users.form.position_placeholder}</option>
                                {usersList.map(user => <option key={user.id} value={user.id}>{user.name}</option>)}
                            </select>
                        </div>
                    </div>
                </div>
                <div className={`step ${user ? (user.role_id === 4 || user.role_id === 6) ? 'show mt-4' : '' : step === 2 ? 'show' : ''}`}>
                    <h3>{messages.users.form.scheduler_title}</h3>
                    <div className="row" style={{ padding: "0 20px" }}>
                        <div className="col-md-6">
                            {
                                formData.schedules?.map((schedule, dayIndex) => (
                                    dayIndex === 6 && <div key={dayIndex} className="row">
                                        <div className="col-md-4">
                                            <span>&nbsp;</span>
                                            <label className="checkbox-container">{daysList[dayIndex]}
                                                <input type="checkbox" checked={schedule?.is_working_day} 
                                                                    onChange={e => setFormData({
                                                                            ...formData,
                                                                            schedules: formData.schedules?.map(item => {
                                                                                    if (item.day === (dayIndex + 1)) {
                                                                                        return { 
                                                                                            ...item, 
                                                                                            is_working_day: e.target.checked,
                                                                                            has_sections: true,
                                                                                            schedule_sections: e.target.checked ? [
                                                                                                {
                                                                                                    from_hour: '',
                                                                                                    to_hour: ''
                                                                                                }
                                                                                            ] : null
                                                                                        }
                                                                                    }
                                                                                    return item
                                                                            })
                                                                    })}/>
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>
                                        <div className="col-md-4">
                                            <span>{messages.users.form.time_from}</span>
                                            <input step={900} type="time" placeholder='1 PM' value={schedule.from_hour} 
                                                                                onChange={e => setFormData({
                                                                                        ...formData,
                                                                                        schedules: formData.schedules?.map(item => {
                                                                                            if (item.day === (dayIndex + 1)) {
                                                                                                return { ...item, from_hour: e.target.value }
                                                                                            }
                                                                                            return item
                                                                                        })
                                                                                })}
                                                                                disabled={!schedule.is_working_day}/>
                                        </div>
                                        <div className="col-md-4">
                                            <span>{messages.users.form.time_to}</span>
                                            <input step={900} type="time" placeholder='1 PM' value={schedule.to_hour} 
                                                                                onChange={e => setFormData({
                                                                                        ...formData,
                                                                                        schedules: formData.schedules?.map(item => {
                                                                                            if (item.day === (dayIndex + 1)) {
                                                                                                return { ...item, to_hour: e.target.value }
                                                                                            }
                                                                                            return item
                                                                                        })
                                                                                })}
                                                                                disabled={!schedule.is_working_day}/>
                                        </div>
                                    </div>
                                ))
                            }
                            {
                                formData.schedules?.map((schedule, dayIndex) => (
                                    dayIndex < 3 && <div key={dayIndex} className="row">
                                        <div className="col-md-4">
                                            <span>&nbsp;</span>
                                            <label className="checkbox-container">{daysList[dayIndex]}
                                                <input type="checkbox" checked={schedule?.is_working_day} 
                                                                    onChange={e => setFormData({
                                                                            ...formData,
                                                                            schedules: formData.schedules?.map(item => {
                                                                                    if (item.day === (dayIndex + 1)) {
                                                                                        return { 
                                                                                            ...item, 
                                                                                            is_working_day: e.target.checked,
                                                                                            has_sections: true,
                                                                                            schedule_sections: e.target.checked ? [
                                                                                                {
                                                                                                    from_hour: '',
                                                                                                    to_hour: ''
                                                                                                }
                                                                                            ] : null
                                                                                        }
                                                                                    }
                                                                                    return item
                                                                            })
                                                                    })}/>
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>
                                        <div className="col-md-4">
                                            <span>{messages.users.form.time_from}</span>
                                            <input step={900} type="time" placeholder='1 PM' value={schedule.from_hour} 
                                                                                onChange={e => setFormData({
                                                                                        ...formData,
                                                                                        schedules: formData.schedules?.map(item => {
                                                                                            if (item.day === (dayIndex + 1)) {
                                                                                                return { ...item, from_hour: e.target.value }
                                                                                            }
                                                                                            return item
                                                                                        })
                                                                                })}
                                                                                disabled={!schedule.is_working_day}/>
                                        </div>
                                        <div className="col-md-4">
                                            <span>{messages.users.form.time_to}</span>
                                            <input step={900} type="time" placeholder='1 PM' value={schedule.to_hour} 
                                                                                onChange={e => setFormData({
                                                                                        ...formData,
                                                                                        schedules: formData.schedules?.map(item => {
                                                                                            if (item.day === (dayIndex + 1)) {
                                                                                                return { ...item, to_hour: e.target.value }
                                                                                            }
                                                                                            return item
                                                                                        })
                                                                                })}
                                                                                disabled={!schedule.is_working_day}/>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                        <div className="col-md-6">
                            {
                                formData.schedules?.map((schedule, dayIndex) => (
                                    dayIndex > 2 && dayIndex < 6 && <div key={dayIndex} className="row">
                                        <div className="col-md-4">
                                            <span>&nbsp;</span>
                                            <label className="checkbox-container">{daysList[dayIndex]}
                                                <input type="checkbox" checked={schedule?.is_working_day} 
                                                                    onChange={e => setFormData({
                                                                            ...formData,
                                                                            schedules: formData.schedules?.map(item => {
                                                                                    if (item.day === (dayIndex + 1)) {
                                                                                        return { 
                                                                                            ...item, 
                                                                                            is_working_day: e.target.checked,
                                                                                            has_sections: true,
                                                                                            schedule_sections: e.target.checked ? [
                                                                                                {
                                                                                                    from_hour: '',
                                                                                                    to_hour: ''
                                                                                                }
                                                                                            ] : null
                                                                                        }
                                                                                    }
                                                                                    return item
                                                                            })
                                                                    })}/>
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>
                                        <div className="col-md-4">
                                            <span>{messages.users.form.time_from}</span>
                                            <input step={900} type="time" placeholder='1 PM' value={schedule.from_hour} 
                                                                                onChange={e => setFormData({
                                                                                        ...formData,
                                                                                        schedules: formData.schedules?.map(item => {
                                                                                            if (item.day === (dayIndex + 1)) {
                                                                                                return { ...item, from_hour: e.target.value }
                                                                                            }
                                                                                            return item
                                                                                        })
                                                                                })}
                                                                                disabled={!schedule.is_working_day}/>
                                        </div>
                                        <div className="col-md-4">
                                            <span>{messages.users.form.time_to}</span>
                                            <input step={900} type="time" placeholder='1 PM' value={schedule.to_hour} 
                                                                                onChange={e => setFormData({
                                                                                        ...formData,
                                                                                        schedules: formData.schedules?.map(item => {
                                                                                            if (item.day === (dayIndex + 1)) {
                                                                                                return { ...item, to_hour: e.target.value }
                                                                                            }
                                                                                            return item
                                                                                        })
                                                                                })}
                                                                                disabled={!schedule.is_working_day}/>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <h3 style={{ marginTop: '40px' }}>{messages.users.form.appointments}</h3>
                    <div className='row' style={{ padding: "0 20px" }}>
                        <div className="col-md-6">
                        {
                                formData.schedules?.map((schedule, dayIndex) => (
                                    dayIndex === 6 && (
                                        <>
                                        {
                                            formData.schedules[dayIndex]?.is_working_day && (
                                                <>
                                                    {
                                                        formData.schedules[dayIndex]?.schedule_sections?.map((option, sectionIndex) => (
                                                            <div className='row' key={sectionIndex}>
                                                                <div className="col-md-3">
                                                                    {sectionIndex === 0 && (
                                                                        <>
                                                                        <span>&nbsp;</span>
                                                                        <label className="checkbox-container">{daysList[dayIndex]}
                                                                            <input type="checkbox" checked={schedule.has_sections} 
                                                                                    onChange={e => setFormData({
                                                                                            ...formData,
                                                                                            schedules: formData.schedules?.map(item => {
                                                                                                    if (item.day === (dayIndex + 1)) {
                                                                                                        return { 
                                                                                                            ...item, 
                                                                                                            has_sections: e.target.checked,
                                                                                                            schedule_sections: [
                                                                                                                {
                                                                                                                    from_hour: '',
                                                                                                                    to_hour: ''
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    }
                                                                                                    return item
                                                                                            })
                                                                                    })}/>
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                        </>
                                                                    )}
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <span>{messages.users.form.time_from}</span>
                                                                    <input  step={900} type="time"
                                                                            min={sectionIndex > 0 && formData.schedules[dayIndex]?.schedule_sections[sectionIndex - 1]?.to_hour}
                                                                            value={option.from_hour} 
                                                                            onChange={e => setFormData({
                                                                                ...formData,
                                                                                schedules: formData.schedules?.map(item => {
                                                                                    if (item.day === (dayIndex + 1)) {
                                                                                        return {
                                                                                            ...item, 
                                                                                            schedule_sections:  item.schedule_sections.map((op, opIndex) => {
                                                                                                if (opIndex === sectionIndex) {
                                                                                                    return { ...op, from_hour: e.target.value }
                                                                                                }
                                                                                                return op
                                                                                            }) 
                                                                                        }
                                                                                    }
                                                                                    return item
                                                                                })
                                                                            })}
                                                                            disabled={!formData.schedules[dayIndex]?.has_sections}/>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <span>{messages.users.form.time_to}</span>
                                                                    <input  step={900} type="time" placeholder='1 PM' 
                                                                            value={option.to_hour} 
                                                                            onChange={e => setFormData({
                                                                                ...formData,
                                                                                schedules: formData.schedules?.map(item => {
                                                                                    if (item.day === (dayIndex + 1)) {
                                                                                        return {
                                                                                            ...item, 
                                                                                            schedule_sections:  item.schedule_sections.map((op, opIndex) => {
                                                                                                if (opIndex === sectionIndex) {
                                                                                                    return { ...op, to_hour: e.target.value }
                                                                                                }
                                                                                                return op
                                                                                            }) 
                                                                                        }
                                                                                    }
                                                                                    return item
                                                                                })
                                                                            })}
                                                                            disabled={!formData.schedules[dayIndex]?.has_sections}/>
                                                                </div>
                                                                <div className="col-md-1">
                                                                    <div className='apps_actions'>
                                                                        {  sectionIndex > 0 && 
                                                                            formData.schedules[dayIndex]?.has_sections && 
                                                                                <button className='close_btn' onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    setFormData({
                                                                                        ...formData,
                                                                                        schedules: formData.schedules?.map(item => {
                                                                                            if (item.day === (dayIndex + 1)) {
                                                                                                return {
                                                                                                    ...item, 
                                                                                                    schedule_sections: item.schedule_sections.filter((op, opIndex) => opIndex !== sectionIndex)
                                                                                                }
                                                                                            }
                                                                                            return item
                                                                                        })
                                                                                    })
                                                                                }}><HighlightOffIcon /></button>}
                                                                        {   sectionIndex === 0 && 
                                                                            formData.schedules[dayIndex]?.has_sections && 
                                                                                <button className='add_btn' 
                                                                                        onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        setFormData({
                                                                                            ...formData,
                                                                                            schedules: formData.schedules?.map(item => {
                                                                                                if (item.day === (dayIndex + 1)) {
                                                                                                    return {
                                                                                                        ...item, 
                                                                                                        schedule_sections: [...item.schedule_sections, { from_hour: '', to_hour: '' }]
                                                                                                    }
                                                                                                }
                                                                                                return item
                                                                                            })
                                                                                        })
                                                                                }}><AddCircleOutlineIcon/></button>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                    }
                                                </>
                                            )
                                        }
                                        </>
                                    )
                                ))
                            }
                            {
                                formData.schedules?.map((schedule, dayIndex) => (
                                    dayIndex < 3 && (
                                        <>
                                        {
                                            formData.schedules[dayIndex]?.is_working_day && (
                                                <>
                                                    {
                                                        formData.schedules[dayIndex]?.schedule_sections?.map((option, sectionIndex) => (
                                                            <div className='row' key={sectionIndex}>
                                                                <div className="col-md-3">
                                                                    {sectionIndex === 0 && (
                                                                        <>
                                                                        <span>&nbsp;</span>
                                                                        <label className="checkbox-container">{daysList[dayIndex]}
                                                                            <input type="checkbox" checked={schedule.has_sections} 
                                                                                    onChange={e => setFormData({
                                                                                            ...formData,
                                                                                            schedules: formData.schedules?.map(item => {
                                                                                                    if (item.day === (dayIndex + 1)) {
                                                                                                        return { 
                                                                                                            ...item, 
                                                                                                            has_sections: e.target.checked,
                                                                                                            schedule_sections: [
                                                                                                                {
                                                                                                                    from_hour: '',
                                                                                                                    to_hour: ''
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    }
                                                                                                    return item
                                                                                            })
                                                                                    })}/>
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                        </>
                                                                    )}
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <span>{messages.users.form.time_from}</span>
                                                                    <input  step={900} type="time" 
                                                                            min={sectionIndex > 0 && formData.schedules[dayIndex]?.schedule_sections[sectionIndex - 1]?.to_hour}
                                                                            value={option.from_hour} 
                                                                            onChange={e => setFormData({
                                                                                ...formData,
                                                                                schedules: formData.schedules?.map(item => {
                                                                                    if (item.day === (dayIndex + 1)) {
                                                                                        return {
                                                                                            ...item, 
                                                                                            schedule_sections:  item.schedule_sections.map((op, opIndex) => {
                                                                                                if (opIndex === sectionIndex) {
                                                                                                    return { ...op, from_hour: e.target.value }
                                                                                                }
                                                                                                return op
                                                                                            }) 
                                                                                        }
                                                                                    }
                                                                                    return item
                                                                                })
                                                                            })}
                                                                            disabled={!formData.schedules[dayIndex]?.has_sections}/>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <span>{messages.users.form.time_to}</span>
                                                                    <input  step={900} type="time" placeholder='1 PM' 
                                                                            value={option.to_hour} 
                                                                            onChange={e => setFormData({
                                                                                ...formData,
                                                                                schedules: formData.schedules?.map(item => {
                                                                                    if (item.day === (dayIndex + 1)) {
                                                                                        return {
                                                                                            ...item, 
                                                                                            schedule_sections:  item.schedule_sections.map((op, opIndex) => {
                                                                                                if (opIndex === sectionIndex) {
                                                                                                    return { ...op, to_hour: e.target.value }
                                                                                                }
                                                                                                return op
                                                                                            }) 
                                                                                        }
                                                                                    }
                                                                                    return item
                                                                                })
                                                                            })}
                                                                            disabled={!formData.schedules[dayIndex]?.has_sections}/>
                                                                </div>
                                                                <div className="col-md-1">
                                                                    <div className='apps_actions'>
                                                                        {  sectionIndex > 0 && 
                                                                            formData.schedules[dayIndex]?.has_sections && 
                                                                                <button className='close_btn' onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    setFormData({
                                                                                        ...formData,
                                                                                        schedules: formData.schedules?.map(item => {
                                                                                            if (item.day === (dayIndex + 1)) {
                                                                                                return {
                                                                                                    ...item, 
                                                                                                    schedule_sections: item.schedule_sections.filter((op, opIndex) => opIndex !== sectionIndex)
                                                                                                }
                                                                                            }
                                                                                            return item
                                                                                        })
                                                                                    })
                                                                                }}><HighlightOffIcon /></button>}
                                                                        {   sectionIndex === 0 && 
                                                                            formData.schedules[dayIndex]?.has_sections && 
                                                                                <button className='add_btn' 
                                                                                        onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        setFormData({
                                                                                            ...formData,
                                                                                            schedules: formData.schedules?.map(item => {
                                                                                                if (item.day === (dayIndex + 1)) {
                                                                                                    return {
                                                                                                        ...item, 
                                                                                                        schedule_sections: [...item.schedule_sections, { from_hour: '', to_hour: '' }]
                                                                                                    }
                                                                                                }
                                                                                                return item
                                                                                            })
                                                                                        })
                                                                                }}><AddCircleOutlineIcon/></button>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                    }
                                                </>
                                            )
                                        }
                                        </>
                                    )
                                ))
                            }
                        </div>
                        <div className="col-md-6">
                        {
                                formData.schedules?.map((schedule, dayIndex) => (
                                    dayIndex > 2 && dayIndex < 6 && (
                                        <>
                                        {
                                            formData.schedules[dayIndex]?.is_working_day && (
                                                <>
                                                    {
                                                        formData.schedules[dayIndex]?.schedule_sections?.map((option, sectionIndex) => (
                                                            <div className='row' key={sectionIndex}>
                                                                <div className="col-md-3">
                                                                    {sectionIndex === 0 && (
                                                                        <>
                                                                        <span>&nbsp;</span>
                                                                        <label className="checkbox-container">{daysList[dayIndex]}
                                                                            <input type="checkbox" checked={schedule.has_sections} 
                                                                                    onChange={e => setFormData({
                                                                                            ...formData,
                                                                                            schedules: formData.schedules?.map(item => {
                                                                                                    if (item.day === (dayIndex + 1)) {
                                                                                                        return { 
                                                                                                            ...item, 
                                                                                                            has_sections: e.target.checked,
                                                                                                            schedule_sections: [
                                                                                                                {
                                                                                                                    from_hour: '',
                                                                                                                    to_hour: ''
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    }
                                                                                                    return item
                                                                                            })
                                                                                    })}/>
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                        </>
                                                                    )}
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <span>{messages.users.form.time_from}</span>
                                                                    <input  step={900} type="time"
                                                                            min={sectionIndex > 0 && formData.schedules[dayIndex]?.schedule_sections[sectionIndex - 1]?.to_hour}
                                                                            value={option.from_hour} 
                                                                            onChange={e => setFormData({
                                                                                ...formData,
                                                                                schedules: formData.schedules?.map(item => {
                                                                                    if (item.day === (dayIndex + 1)) {
                                                                                        return {
                                                                                            ...item, 
                                                                                            schedule_sections:  item.schedule_sections.map((op, opIndex) => {
                                                                                                if (opIndex === sectionIndex) {
                                                                                                    return { ...op, from_hour: e.target.value }
                                                                                                }
                                                                                                return op
                                                                                            }) 
                                                                                        }
                                                                                    }
                                                                                    return item
                                                                                })
                                                                            })}
                                                                            disabled={!formData.schedules[dayIndex]?.has_sections}/>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <span>{messages.users.form.time_to}</span>
                                                                    <input  step={900} type="time" placeholder='1 PM' 
                                                                            value={option.to_hour} 
                                                                            onChange={e => setFormData({
                                                                                ...formData,
                                                                                schedules: formData.schedules?.map(item => {
                                                                                    if (item.day === (dayIndex + 1)) {
                                                                                        return {
                                                                                            ...item, 
                                                                                            schedule_sections:  item.schedule_sections.map((op, opIndex) => {
                                                                                                if (opIndex === sectionIndex) {
                                                                                                    return { ...op, to_hour: e.target.value }
                                                                                                }
                                                                                                return op
                                                                                            }) 
                                                                                        }
                                                                                    }
                                                                                    return item
                                                                                })
                                                                            })}
                                                                            disabled={!formData.schedules[dayIndex]?.has_sections}/>
                                                                </div>
                                                                <div className="col-md-1">
                                                                    <div className='apps_actions'>
                                                                        {  sectionIndex > 0 && 
                                                                            formData.schedules[dayIndex]?.has_sections && 
                                                                                <button className='close_btn' onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    setFormData({
                                                                                        ...formData,
                                                                                        schedules: formData.schedules?.map(item => {
                                                                                            if (item.day === (dayIndex + 1)) {
                                                                                                return {
                                                                                                    ...item, 
                                                                                                    schedule_sections: item.schedule_sections.filter((op, opIndex) => opIndex !== sectionIndex)
                                                                                                }
                                                                                            }
                                                                                            return item
                                                                                        })
                                                                                    })
                                                                                }}><HighlightOffIcon /></button>}
                                                                        {   sectionIndex === 0 && 
                                                                            formData.schedules[dayIndex]?.has_sections && 
                                                                                <button className='add_btn' 
                                                                                        onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        setFormData({
                                                                                            ...formData,
                                                                                            schedules: formData.schedules?.map(item => {
                                                                                                if (item.day === (dayIndex + 1)) {
                                                                                                    return {
                                                                                                        ...item, 
                                                                                                        schedule_sections: [...item.schedule_sections, { from_hour: '', to_hour: '' }]
                                                                                                    }
                                                                                                }
                                                                                                return item
                                                                                            })
                                                                                        })
                                                                                }}><AddCircleOutlineIcon/></button>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                    }
                                                </>
                                            )
                                        }
                                        </>
                                    )
                                ))
                            }
                        </div>
                    </div>
                </div>
                <div className='form-footer'>
                    <p>&nbsp;{feedback}</p>
                    <div className="actions">
                        {
                            !user && isMultiSteps && step === 1 ? (<button type="button" className="myBtn" onClick={(e) => handleNext(e)}>{messages.users.form.btn_next}</button>)
                                        : (<button type="button" className="myBtn" onClick={(e) => handleSave(e)}>{messages.users.form.btn_save}</button>)
                        }
                        <button type="button" className="myBtn cancel" onClick={e => handleBack(e)}>{user || step === 1 ? messages.users.form.btn_cancel : messages.users.form.btn_back }</button>
                    </div>
                </div>
            </form>
            <ConfirmDialog show={cancelConfirmation} 
                     onCancel={() => setCancelConfirmation(false)}
                     onConfirm={() => {
                        setCancelConfirmation(false);
                        clear();
                        history.push('/users/internal');
                     }}
                     icon={null}
                     content={messages.warningMsgs.warning_close_window}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
        </div>
    );
}

export default injectIntl(UserForm);
